import i18n from '@/i18n'
import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'

const baseUrl = '/v-admin/referral/client-admin/cash-out-management'

export default {
  name: 'cashOutManagement',
  path: `${baseUrl}/`,
  redirect: `${baseUrl}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_COMPANY_APPROVAL'],
    titleI18nKey: 'admin.company.cashOutManagement.title.cashOutManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.cashOutManagement.menu.cashOutManagement')
      }
    }
  },
  children: [
    {
      path: `${baseUrl}/list`,
      component: Index,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.cashOutManagement.title.cashOutManagement'
      }
    }
  ]
}
